import { createFileRoute } from '@tanstack/react-router';

import Overview from '~/app/overview/Overview';

export const Route = createFileRoute('/_app/home/overview/')({
	beforeLoad: () => {
		return {
			getTitle: undefined
		};
	},
	component: function OverviewPage() {
		return <Overview />;
	}
});
